import { graphql } from 'react-relay';

export type { NftExhibitionsEntryQuery as NftExhibitionsEntryQueryType } from './__generated__/NftExhibitionsEntryQuery.graphql.ts';

export const NftExhibitionsEntryQuery = graphql`
    query NftExhibitionsEntryQuery {
        viewer {
            ...NftExhibitionsLayout_viewer
            ...NftHeaderLayout_viewer
        }
    }
`;
